export default {
  devicepolicyname: {
    dependent: '',
    header: 'Name & Description',
    headercss: 'vmHeader',
    subheader: 'Device Name',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  description: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Breif description about this device',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  clockinmodeid: [{
    1: {
      dependent: '',
      header: 'Input Type',
      headercss: 'vmHeader',
      subheader: 'Do employees need to clock-in and clock-out, or only clock-in is sufficient?',
      subheadercss: 'vmSubHeader',
      values: 'Clock-in and Clock-out are required',
    },
    2: {
      dependent: '',
      header: 'Input Type',
      headercss: 'vmHeader',
      subheader: 'Do employees need to clock-in and clock-out, or only clock-in is sufficient?',
      subheadercss: 'vmSubHeader',
      values: 'Only Clock-in is required (Clock-out is optional)',
    },
  }],
  isbreakon: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Would you like to track break durations between Clock-out and Clock-in times?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  isbiometricdevice: {
    dependent: '',
    header: 'Biometric',
    headercss: 'vmHeader',
    subheader: 'Would you like to enable biometric attendance?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  isbidirection: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Do you wish to track attendance with separate device for recording in-time and a separate device for recording out-time (use in/out directional devices)?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  iswebdevice: {
    dependent: '',
    header: 'Web',
    headercss: 'vmHeader',
    subheader: 'Would you like to enable Web based attendance?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  allowedweddeviceip: [{
    locationname: {
      dependent: 'iswebdevice',
      header: 'Selected IPs',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    ipaddresslist: [
      {
        iptype: {
          dependent: 'iswebdevice',
          header: '',
          headercss: 'vmHeader',
          subheader: 'Type',
          subheadercss: 'vmSubHeader',
          values: '<val>',
        },
        fromip: {
          dependent: 'iswebdevice',
          header: '',
          headercss: 'vmHeader',
          subheader: 'From',
          subheadercss: 'vmSubHeader',
          values: '<val>',
        },
        toip: {
          dependent: 'iswebdevice',
          header: '',
          headercss: 'vmHeader',
          subheader: 'To',
          subheadercss: 'vmSubHeader',
          values: '<val>',
        },
      },
    ],
    iptype: {
      dependent: 'iswebdevice',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Type',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    fromip: {
      dependent: 'iswebdevice',
      header: '',
      headercss: 'vmHeader',
      subheader: 'From',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    toip: {
      dependent: 'iswebdevice',
      header: '',
      headercss: 'vmHeader',
      subheader: 'To',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
  }],
  isiprestricted: {
    dependent: 'iswebdevice',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Would you like to enforce IP Network restrictions as well?				',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  ismobiledevice: {
    dependent: '',
    header: 'Mobile',
    headercss: 'vmHeader',
    subheader: 'Would you like to enable Mobile App based attendance?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  isgpsrestricted: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Would you like to enforce GPS location based attendance?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  allowedmobiledevicegps: [
    {
      locationname: {
        dependent: 'ismobiledevice',
        header: 'GPS co-ordinates',
        headercss: 'vmHeader',
        subheader: 'Location',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      latitude: {
        dependent: 'ismobiledevice',
        header: '',
        headercss: 'vmHeader',
        subheader: 'Latitude',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      longitude: {
        dependent: 'ismobiledevice',
        header: '',
        headercss: 'vmHeader',
        subheader: 'Longitude',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      isautopunch: {
        dependent: 'ismobiledevice',
        header: '',
        headercss: 'vmHeader',
        subheader: 'Would you like to automatically mark the employee’s attendance based on their mobile device’s GPS location?',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      ispunchoutofradius: {
        dependent: 'ismobiledevice',
        header: '',
        headercss: 'vmHeader',
        subheader: 'Would you like to automatically send a request for approval in case the Clock-in/out is attempted from outside the location radius?',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
    },
  ],

};
